import { AppState } from 'src/store/root-reducer'

export const selectImage = (identifier: string | null) => (state: AppState) => {
  if (!identifier) {
    return null
  }
  return state.assets[identifier] || null
}
